import { requireNativeComponent } from 'react-native';
import type { WaveformSeekBarProps } from './index';

export default requireNativeComponent<WaveformSeekBarProps>(
  'WaveformSeekBarView'
);
